import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import StatusScreen from './StatusScreen';

/**
 * Layout route that admits only an authenticated session.
 *
 * Anonymous visitors are redirected to /login, carrying the attempted location
 * so that signing in returns them to the deep link they asked for.
 */
export default function ProtectedRoute() {
  const { status, error, refresh, signOut } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <StatusScreen title="Проверка сессии…" description="Загружаем профиль пользователя." />;
  }

  if (status === 'error') {
    return (
      <StatusScreen
        tone="alert"
        kicker="Сервер недоступен"
        title="Не удалось подтвердить сессию"
        description={error ?? 'Профиль пользователя временно недоступен.'}
        action={
          <>
            <button type="button" className="button button--primary" onClick={() => void refresh()}>
              Повторить
            </button>
            <button type="button" className="button" onClick={signOut}>
              Выйти
            </button>
          </>
        }
      />
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
